import EntityCard from '@/components/EntityCard';
import { Service } from '@/types';

type ServiceDetail = Pick<Service, 'title' | 'summary' | 'image_url'> & {
  slug: string;
};

/**
 * Services had no card component at all — every listing hand-rolled the same
 * markup as CourseCard with a different hover treatment.
 */
const ServiceCard = ({ service }: { service: ServiceDetail }) => {
  // aspect 16:9 rather than the 4:3 default, matching CourseCard — the taller
  // crop left the image occupying more of the card than the service name.
  return (
    <EntityCard
      href={route('services.showService', service.slug)}
      aspect="video"
      image={service.image_url}
      alt={service.title}
      title={service.title}
      description={service.summary}
    />
  );
};

export default ServiceCard;
